import { User, AdminPermission } from '../types';

// 权限判断唯一入口:业务代码不得直接比较 user.role(spec 4.1)。
export function isAdminTier(user: User | null | undefined): boolean {
  return user?.role === 'admin' || user?.role === 'super_admin';
}

export function isSuperAdmin(user: User | null | undefined): boolean {
  return user?.role === 'super_admin';
}

export function hasPermission(user: User | null | undefined, group: AdminPermission): boolean {
  if (!user) return false;
  if (user.role === 'super_admin') return true;
  if (user.role !== 'admin') return false;
  return (user.permissions ?? []).includes(group);
}
